import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useInvalidateCache } from "~hooks/useInvalidateCache.ts";
import { useUpdatePermissionScopeCache } from "~hooks/useUpdatePermissionScopeCache.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteEntityGroup = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();
  const { mutateAsync: invalidateCache } = useInvalidateCache();
  const updatePermissionScopeCache = useUpdatePermissionScopeCache();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (entityGroupId: string) => {
      return await request(`${sport}/o/${organizationId}/entityGroups/${entityGroupId}`, { method: "DELETE" });
    },
    onSuccess: async (response, entityGroupId) => {
      const operationResult = response?.data?.[0];

      if (!operationResult?.success) {
        return;
      }

      updatePermissionScopeCache(sport, organizationId, (updatedScope) => {
        updatedScope.scope.entityGroupTree = updatedScope.scope.entityGroupTree.filter(({ entityGroupId: id }) => id !== entityGroupId);

        if (updatedScope.resources?.entityGroups?.[entityGroupId]) {
          delete updatedScope.resources.entityGroups[entityGroupId];
        }
      });

      await Promise.all([invalidateCache(), queryClient.invalidateQueries({ queryKey: ["teamGroups", sport, organizationId] })]);
    },
  });
};
